var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrionToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 14,
    viewBox: "0 0 48 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66193 14C6.36485 14 5.18741 13.6881 4.1296 13.0642C3.07179 12.4403 2.24065 11.598 1.63619 10.5374C1.03172 9.46436 0.729492 8.28521 0.729492 7C0.729492 5.72728 1.03172 4.55437 1.63619 3.48129C2.24065 2.4082 3.07179 1.55972 4.1296 0.93583C5.18741 0.311943 6.36485 0 7.66193 0C8.95901 0 10.1365 0.311943 11.1943 0.93583C12.2521 1.55972 13.0832 2.4082 13.6877 3.48129C14.3047 4.55437 14.6133 5.72728 14.6133 7C14.6133 8.28521 14.311 9.46436 13.7066 10.5374C13.1021 11.598 12.2647 12.4403 11.1943 13.0642C10.1365 13.6881 8.95901 14 7.66193 14ZM7.66193 12.484C8.63159 12.484 9.51939 12.2531 10.3253 11.7915C11.1439 11.3173 11.7861 10.6685 12.2521 9.84492C12.7306 9.00892 12.9699 8.06061 12.9699 7C12.9699 5.9394 12.7306 4.99733 12.2521 4.1738C11.7861 3.33779 11.1439 2.68895 10.3253 2.22727C9.51939 1.75312 8.63159 1.51604 7.66193 1.51604C6.69227 1.51604 5.80446 1.75312 4.99851 2.22727C4.19256 2.68895 3.55032 3.33779 3.07179 4.1738C2.59325 5.00981 2.35399 5.95188 2.35399 7C2.35399 8.04813 2.59325 8.9902 3.07179 9.82621C3.55032 10.6622 4.19256 11.3173 4.99851 11.7915C5.80446 12.2531 6.69227 12.484 7.66193 12.484Z",
    fill: "#1E2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 4.15508H18.1871V5.68984H18.2626C18.4515 5.16578 18.8167 4.7353 19.3582 4.3984C19.8997 4.04902 20.4664 3.87433 21.0583 3.87433C21.499 3.87433 21.8768 3.93672 22.1916 4.0615V5.78343C21.7886 5.58378 21.3353 5.48396 20.8316 5.48396C20.3656 5.48396 19.9375 5.61498 19.5471 5.87701C19.1567 6.13904 18.8419 6.49466 18.6026 6.94385C18.376 7.38058 18.2626 7.85473 18.2626 8.36631V13.7005H16.657V4.15508Z",
    fill: "#1E2021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.685 2.39572C24.3702 2.39572 24.0995 2.28342 23.8728 2.05882C23.6461 1.83423 23.5328 1.56595 23.5328 1.25401C23.5328 0.942068 23.6461 0.680036 23.8728 0.467915C24.0995 0.243316 24.3702 0.131017 24.685 0.131017C24.9999 0.131017 25.2706 0.243316 25.4973 0.467915C25.724 0.680036 25.8373 0.942068 25.8373 1.25401C25.8373 1.56595 25.724 1.83423 25.4973 2.05882C25.2832 2.28342 25.0125 2.39572 24.685 2.39572ZM23.8917 4.15508H25.4784V13.7005H23.8917V4.15508Z",
    fill: "#1E2021"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3486 14C31.4041 14 30.5541 13.7754 29.7985 13.3262C29.0429 12.877 28.451 12.2656 28.0229 11.492C27.6073 10.7184 27.3995 9.86364 27.3995 8.92781C27.3995 7.99198 27.6073 7.13726 28.0229 6.36364C28.451 5.59002 29.0429 4.97861 29.7985 4.52942C30.5541 4.08022 31.4041 3.85562 32.3486 3.85562C33.293 3.85562 34.1431 4.08022 34.8986 4.52942C35.6542 4.97861 36.2398 5.59002 36.6554 6.36364C37.0835 7.13726 37.2976 7.99198 37.2976 8.92781C37.2976 9.86364 37.0835 10.7184 36.6554 11.492C36.2398 12.2656 35.6542 12.877 34.8986 13.3262C34.1431 13.7754 33.293 14 32.3486 14ZM32.3486 12.5588C32.9404 12.5588 33.4882 12.4153 33.9919 12.1283C34.5083 11.8289 34.9175 11.4046 35.2198 10.8556C35.5346 10.3066 35.692 9.664 35.692 8.92781C35.692 8.19163 35.5346 7.54902 35.2198 7C34.9175 6.45098 34.5083 6.03298 33.9919 5.74599C33.4882 5.44653 32.9404 5.29679 32.3486 5.29679C31.7567 5.29679 31.2026 5.44653 30.6863 5.74599C30.17 6.03298 29.7544 6.45098 29.4396 7C29.1373 7.54902 28.9862 8.19163 28.9862 8.92781C28.9862 9.664 29.1373 10.3066 29.4396 10.8556C29.7544 11.4046 30.17 11.8289 30.6863 12.1283C31.2026 12.4153 31.7567 12.5588 32.3486 12.5588Z",
    fill: "#1E2021"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9776 4.15508H40.5076V5.55883H40.5832C40.8476 5.08467 41.2695 4.68539 41.8488 4.36097C42.4281 4.02407 43.0451 3.85562 43.6999 3.85562C44.8585 3.85562 45.74 4.19252 46.3445 4.86631C46.9615 5.52763 47.2701 6.43227 47.2701 7.58022V13.7005H45.6645V7.82353C45.6645 6.93762 45.4504 6.29501 45.0222 5.89573C44.5941 5.49644 44.0085 5.29679 43.2655 5.29679C42.7492 5.29679 42.2832 5.44029 41.8677 5.72728C41.4647 6.01426 41.1499 6.39483 40.9232 6.86899C40.6965 7.33066 40.5832 7.8173 40.5832 8.32888V13.7005H38.9776V4.15508Z",
    fill: "#1E2021"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.773,
    cy: 1.21739,
    rx: 1.21739,
    ry: 1.21739,
    fill: "#00AC47"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3142_48631)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_3142_48631_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.00278624 0.00278624 0 32.4279 8.89192)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2374.94,
    y: -2374.94,
    width: 4749.88,
    height: 4749.88
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(160, 126, 255, 1) 0deg,rgba(0, 0, 0, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4189,
    cy: 8.89192,
    rx: 5.10811,
    ry: 5.10811,
    transform: "rotate(90 32.4189 8.89192)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.62770730257034302,\"g\":0.49441730976104736,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.62770730257034302,\"g\":0.49441730976104736,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-8.6386200113825612e-14,\"m01\":5.5724835395812988,\"m02\":29.641666412353516,\"m10\":-5.5724844932556152,\"m11\":3.5034126343253327e-14,\"m12\":11.678166389465332},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.552 9.75873C30.9741 9.18085 30.2698 8.8919 29.4391 8.8919C30.2698 8.8919 30.9741 8.60296 31.552 8.02507C32.1299 7.44718 32.4189 6.74288 32.4189 5.91217C32.4189 6.74288 32.7078 7.44718 33.2857 8.02507C33.8636 8.60296 34.5679 8.8919 35.3986 8.8919C34.5679 8.8919 33.8636 9.18085 33.2857 9.75873C32.7078 10.3366 32.4189 11.0409 32.4189 11.8716C32.4189 11.0409 32.1299 10.3366 31.552 9.75873Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3142_48631",
    x: 27.3108,
    y: 2.78381,
    width: 11.2162,
    height: 11.2162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3142_48631"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3142_48631",
    result: "effect2_innerShadow_3142_48631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_3142_48631_clip_path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4189,
    cy: 8.89192,
    rx: 5.10811,
    ry: 5.10811,
    transform: "rotate(90 32.4189 8.89192)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrionToggleIcon);
export default __webpack_public_path__ + "static/media/orion_toggle_icon.85c2fe6e8e0672dd99df44f8fdb8fcf0.svg";
export { ForwardRef as ReactComponent };